import IPCCenter from "@js/ipc";
import { EVENTCMD } from "@js/events";

export default class CheckGameingWindow {
  // 是否正在等待是否存在游戏页面的判断
  static waitingEchoExistGameWindow = false;

  // 检测当前是否有游戏窗口正在运行
  static async checkIfExistGamingWindow(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      IPCCenter.getInstance().broadCastEvent(EVENTCMD.checkGameWidnowExist, {});

      CheckGameingWindow.waitingEchoExistGameWindow = true;

      setTimeout(function () {
        if (CheckGameingWindow.waitingEchoExistGameWindow) {
          resolve(false);
        } else {
          resolve(true);
        }

        CheckGameingWindow.waitingEchoExistGameWindow = false;
      }, 1000);
    });
  }
}
